
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class IcWhsDialog extends Serenity.EntityDialog<IcWhsRow, any> {
        protected getFormKey() { return IcWhsForm.formKey; }
        protected getIdProperty() { return IcWhsRow.idProperty; }
        protected getLocalTextPrefix() { return IcWhsRow.localTextPrefix; }
        protected getNameProperty() { return IcWhsRow.nameProperty; }
        protected getService() { return IcWhsService.baseUrl; }
        protected getDeletePermission() { return IcWhsRow.deletePermission; }
        protected getInsertPermission() { return IcWhsRow.insertPermission; }
        protected getUpdatePermission() { return IcWhsRow.updatePermission; }

        protected form = new IcWhsForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Icwhsid = Q.tryFirst(PsPosStationRow.getLookup().items,x => x.WhsId == this.entity.WhsId);
            if(Icwhsid !=null){
                this.deleteButton.toggleClass('disabled', true);
                
                
            }
            var Icwhsids = Q.tryFirst(Inventory.IcStockTranRow.getLookup().items,x => x.WhsId == this.entity.WhsId);
            if(Icwhsids !=null){
                this.deleteButton.toggleClass('disabled', true);
                
                
            }
        }
       
    }
}